/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb1_Point_0_TextInputs */

const en_visa_eb1_point_0_text = /** @type {(inputs: Visa_Eb1_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We assess the full record of a client's work, recognition, leadership, and impact rather than relying on a narrow job-title checklist.`)
};

const pt_visa_eb1_point_0_text = /** @type {(inputs: Visa_Eb1_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avaliamos o registro completo do trabalho, reconhecimento, liderança e impacto do cliente, em vez de depender de uma lista restrita de cargos.`)
};

const es_visa_eb1_point_0_text = /** @type {(inputs: Visa_Eb1_Point_0_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evaluamos el registro completo del trabajo, reconocimiento, liderazgo e impacto del cliente, en lugar de depender de una lista restringida de cargos.`)
};

/**
* | output |
* | --- |
* | "We assess the full record of a client's work, recognition, leadership, and impact rather than relying on a narrow job-title checklist." |
*
* @param {Visa_Eb1_Point_0_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb1_point_0_text = /** @type {((inputs?: Visa_Eb1_Point_0_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb1_Point_0_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb1_point_0_text(inputs)
	if (locale === "es") return es_visa_eb1_point_0_text(inputs)
	return en_visa_eb1_point_0_text(inputs)
});